import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Card, Button, SocialIcons, Modal, LockCard, Select } from "../../../common";
import CompanyBanner from "../../../../assets/images/companyProfileBanner.jpg";
import { ReactComponent as RightArrow } from "../../../../assets/icons/rightArrowOrange.svg";
import { ReactComponent as ProfileImage } from "../../../../assets/images/profile.svg";
import { ReactComponent as GroupUser } from "../../../../assets/icons/groupUser.svg";
import { ReactComponent as Calender } from "../../../../assets/icons/calender.svg";
import { ReactComponent as Rocket } from "../../../../assets/images/rocket.svg";
import { ReactComponent as Flag } from "../../../../assets/images/flag.svg";
import { ReactComponent as HelpIcon } from "../../../../assets/images/HelpIcon.svg";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as Plus } from "../../../../assets/icons/plus.svg";
import { ReactComponent as Verified } from "../../../../assets/icons/Verified-Check.svg";
import { ReactComponent as VerifyFilled } from "../../../../assets/icons/Verified-Check-White.svg";
import RoundedVerifyFilled from "../../../../assets/icons/verifiedCheck.png";
import { ReactComponent as Verify } from "../../../../assets/icons/verify.svg";
import { ReactComponent as Linkedin } from "../../../../assets/icons/socialIcons/linkedinIcon.svg";
import { ReactComponent as Twitter } from "../../../../assets/icons/socialIcons/TWITTER.svg";
import { ReactComponent as Instagram } from "../../../../assets/icons/socialIcons/instagramicon.svg";
import { ReactComponent as Facebook } from "../../../../assets/icons/socialIcons/FACEBOOK.svg";
import { ReactComponent as Global } from "../../../../assets/icons/socialIcons/GlobeIcon.svg";
import { ReactComponent as Share } from "../../../../assets/icons/socialIcons/ShareIcon.svg";
import { VerifiedByTrevex } from "../../../common/badges/VerifiedByTrevex.jsx";
import { ReactComponent as Whatsapp } from "../../../../assets/icons/socialIcons/Whatsapp.svg";
import { ReactComponent as Facebook2 } from "../../../../assets/icons/socialIcons/Facebook2.svg";
import { ReactComponent as Twiter2 } from "../../../../assets/icons/socialIcons/Twiter2.svg";
import { ReactComponent as Linkdin2 } from "../../../../assets/icons/socialIcons/Linkdin2.svg";
import { ReactComponent as Gmail2 } from "../../../../assets/icons/socialIcons/Gmail2.svg";
import { ReactComponent as Telegram2 } from "../../../../assets/icons/socialIcons/Telegram2.svg";
import { ReactComponent as BrownCheck } from "../../../../assets/icons/brownCheck.svg";
import { ReactComponent as Messenger } from "../../../../assets/icons/socialIcons/Messenger.svg";
import { ReactComponent as PTEndorse } from "../../../../assets/icons/pt_endorsements_icon.svg";
import { Countries } from "../../../../components/public/Home/CountryFlag";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Copy } from "../../../../assets/icons/socialIcons/Copy.svg";
import { ReactComponent as Delete } from "../../../../assets/images/companyIcons/delete.svg";
import { GetTheCompany } from "../../../common";
import { IsTrevexCompany } from "../../../common/IsTrevexCompany";
import right from "../../../../assets/icons/verify3.png";
import { ReactComponent as VerifyImage } from "../../../../assets/icons/verifyIcon.svg";
import { useSelector } from "react-redux";
import { convertLetterCase, isVerified, validateEmail } from "../../../../utils/Helper";
import { ReactComponent as EndorsementIcon } from '../../../../assets/endorseBanner/building-endorsement-icon.svg';
import { ReactComponent as GrayHelp } from '../../../../assets/endorseBanner/help-Icon-blue.svg';
import {
  addEllipsisAfter50Words,
  getCountryByCode,
} from "../../../../utils/Helper";
import { useGetCompanyNewQuery } from "../../../../store/search/searchApiSlice";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isWithinInterval, parseISO } from 'date-fns';

import {
  useCreateCompanyMutation,
  useCreateCompanyFollowMutation,
  useCreateCompanyViewedDetailsMutation,
  useCreateCompanyUserInviteMutation,
  useGetCompanyUserListMutation,
  useCreateWorldBoxOrderMutation,
  useGetPurchaseDetailsQuery,
  useGetCompanyPurchaseDetailsMutation,
  useGetCompanyWorldboxstatusMutation,
  useCreatePurchaseDetailsMutation,
  useDeleteCompanyFollowMutation,
  useGetCompanyReportMutation,
  useCreateCompanyUserRoleUpdateMutation,
  useCreateCompanyUserRoleDeleteMutation,
  useGetEndorsementsQuery,
  useRequestVerificationMutation
} from "../../../../store/Company/companyApiSlice";
import { selectActiveCompanyId } from "../../../../store/activeCompanySlice";
import authSlice from "../../../../store/auth/authSlice";
import { formatDateToISO } from "../../../../utils/Helper";
import useOutsideClick from "../../../../Hooks/useOutsideClick";

import {
  formatDateWithOrdinal,
  toSentenceCaseCP,
} from "../../../../global_functions/global";
import { PurchaseSuccess } from "../../../common/PurchaseSuccess";
import { CreditNotice } from "../../../common/CreditNotice";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import CommonTooltip from "../../../common/Tooltip.jsx";
import Toster, { CommonToast } from "../../../common/Toast.jsx";
import EndorsementButton from "./components/Endorsement/EndorsementButton.jsx";
import { GetMembershipButton } from "./GetMembershipButton.jsx";
import { ProfileMembershipCta } from "./ProfileMembershipCta.jsx";
import { ReactComponent as AlertIcon } from "../../../../assets/icons/alert_icon.svg";
import EndorsementBanner from "../../../common/badges/EndorsementBanner.jsx";
import useScreenSize from "../../../../Hooks/useScreenSize.js";
import ToolTip from "./components/assets/ToolTip.jsx";
import { COMPANY_URL } from "../../../../constants/apiUrls.js";
import { pgColors } from "../../../../constants/constants.js";
import ReactGA from "react-ga4";
import { format, addMonths, isAfter, isEqual } from 'date-fns';
import { useMemo } from "react";
import CompanySocialIcons from "./CompanySocialIcons.jsx";
import EnterpriseAddCompany from "../../../common/EnterpriseAddCompany.jsx";

// TIP-489 — legacy plan object retained only for the commented-out paid path
// below. Membership is now purchased via /membership/:companyId (see
// GetMembershipButton); no live CTA renders this plan. The `slug` is left as
// the original internal key so the shared /plans/paymentdetails flow is
// undisturbed; only the user-facing copy is de-"verified".
const plansInformation = [
  {
    title: "Membership",
    slug: "verify_company",
    mode: "one-time",
    subsCharge: 199,
    subsDuration: "per year",
    talkToSales: true,
    Features: [
      "Boost your profile credibility",
      "Eligible for the free verified badge",
      "Priority placement in search",
      "Annual membership",
    ],
  },
];
const moreOptions = [
  {
    name: "Save Company as PDF",
    file_url: "https://cdn-icons-png.flaticon.com/512/2989/2989976.png",
  },
  {
    name: "Manage Roles",
    file_url: "https://cdn-icons-png.flaticon.com/512/2099/2099058.png",
  },
  // {
  //   name: "Email Prefenences",
  //   file_url: "https://cdn-icons-png.flaticon.com/512/542/542638.png",
  // },
];

const company_url = window.location.href;

function toSentenceCase(str) {
  str = str.trim().toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const BannerCompanyCard = ({
  company,
  trevexId,
  getDetailsClicked,
  setGetDetailsClicked,
  selectedEnterprise,
  setSelectedEnterprise,
  userEnterprise,
  secondayListedHandler,
  formData,
  setFormData,
  individualData,
  refetch,
  creditNoticePopup,
  setCreditNoticePopup,
  setIsContinue,
  isContinue,
  SubscriptionActive,
  handleGetCompanyPopup,
  isGetTheCompanyOpen
}) => {
  //Note: Component Refactor needed to optimize the performance of this page.
  let companyIDUser = company?.companyID;
  const moreOptionRef = useRef();
  const moreButtonOptionRef = useRef(null);
  const company_urlRef = useRef(null);
  const [subscriptionActive, setSubscriptionActive] = useState();
  const [shareUrl, setShareURL] = useState(window.location.href)
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [creditType, setCreditType] = useState("credit");
  const [moreOptionPosition, setMoreOptionPosition] = useState('towardsRight')
  const [data, setData] = useState();
  useEffect(() => {
    if (individualData?.individualID) {
      setData(individualData);
    }
  }, [individualData])

  // const [userEnterprise, setUserEnterprise] = useState([]);
  const [inviteData, setInviteData] = useState({
    email: "",
    role: "AD",
    name: "",
  });
  const [usersData, setUsersData] = useState([]);
  const [isRoleManageOpen, setRoleManageOpen] = useState(false);
  const [isFollowed, setIsFollowed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [RequestIndividualStatus, setRequestIndividualStatus] = useState(false);
  // const [selectedEnterprise, setSelectedEnterprise] = useState();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [notTrevexCompany, setNotTrevexCompany] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [flag, setFlag] = useState("");
  const [verifiedCompany, setVerifiedCompany] = useState(false);
  const [industry, setIndustry] = useState("");
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token, userInfo } = useSelector((state) => state.auth);
  const [compSubsEnd, setCompSubsEnd] = useState("");
  const [purchasedCompanyPopup, setPurchasedCompanyPopup] = useState(false);
  const [createPurchaseDetails] = useCreatePurchaseDetailsMutation();
  const [copyText, setCopyText] = useState("click here to copy");
  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const [triggerPurchaseApi, setTriggerPurchaseApi] = useState(false)

  useEffect(() => {
    if (SubscriptionActive?.subscriptionID) {
      setSubscriptionActive(SubscriptionActive)
    }
  }, [SubscriptionActive])
  let companyId = userInfo?.individual[0]?.individual[0]?.companyID?.companyID;
  let claimed = userInfo?.individual[0]?.individual[0]?.companyID?.claimed;
  const arr = userInfo?.companyFollow || [];
  const arr1 = userInfo?.individual[0]?.individual || [];

  const companyIdArray = arr.map((company) => company?.companyID?.companyID);
  const companyArr = arr1.map((company) => company?.companyID?.companyID);
  const claimedCompanies = arr1.map((claimed) => claimed?.companyID?.claimed);
  const WB_ID = userInfo?.companyFollow;
  const WBIdArray = arr.map((company) => company?.companyID?.wb_win);
  const companyDetails = arr1.map((company) => company?.companyID);

  // useMemo(() => {
  //   const filteredEnterpriseForCredit = userInfo?.enterprise_solutions?.filter(({ credits }) => credits !== undefined && credits !== null && credits > 0);
  //   setUserEnterprise(filteredEnterpriseForCredit)
  // }, [userInfo])

  const companyExists =
    userInfo &&
    userInfo?.individual[0]?.individual.some(
      (item) =>
        item?.companyID && item?.companyID?.companyID === company?.companyID
    );

  const [companyViewedDetails] = useCreateCompanyViewedDetailsMutation();
  const [getPurchaseDetailsStatus] = useGetCompanyPurchaseDetailsMutation();
  const [checkworldboxStatus] = useGetCompanyWorldboxstatusMutation();
  const [WorldboxStatus, setWorldboxStatus] = useState("");
  const [profileStart, setProfileStart] = useState();
  const [personalPurchase, setPersonalPurchase] = useState(false)

  const { wb_id } = useParams();
  const { id } = useParams();
  const [userInvite, { isLoading: isInviteApiLoading }] = useCreateCompanyUserInviteMutation();
  const [userRoleUpdate, { isLoading: isRoleUpdateLoading }] = useCreateCompanyUserRoleUpdateMutation()
  const [userRoleDelete, { isLoading: isRoleDeleteLoading }] = useCreateCompanyUserRoleDeleteMutation()
  const [GetCompanyuserList] = useGetCompanyUserListMutation();
  const [exporttoPDFReport] = useGetCompanyReportMutation();
  const [PDFExporting, setexporttoPDF] = useState(false);
  const [updateList, setUpdateList] = useState(false);



  const companyInfo = arr1.find(company => company.companyID?.companyID === id);
  const role = companyInfo ? companyInfo.role : undefined;

  let companyDet = [];
  const currentCompany = companyArr.filter((item) => {
    if (item === id) {
      return item;
    }
  });
  if (currentCompany.length > 0) {
    companyDet = companyDetails.filter((item) => {
      if (item?.companyID == currentCompany[0]) {
        return item;
      }
    });
  }
  function addEllipsisAfter50Words(text) {
    if (typeof text === "string") {
      const words = text.split(" ");
      if (words.length > 50) {
        return words.slice(0, 50).join(" ") + " ...";
      }
    }
    return text;
  }
  useOutsideClick(moreOptionRef, () => {
    if (isMoreOpen) setIsMoreOpen(false);
  });
  const checkURL = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      url = 'http://' + url;
    }
    return url;
  }

  const companyType = company?.companyID === undefined
    ? "listing"
    : company?.verifiedCompany != null
      ? "verified"
      : (company?.claimed && "claimed") ||
      (company?.draft && "warning")

  useEffect(() => {
    (async () => {
      if (
        company &&
        company?.industry !== null &&
        company?.industry !== undefined
      ) {
        setIndustry(company?.industry);
      }
      if (company) {
        let status =
          company?.companyID === undefined
            ? "listing"
            : company?.verifiedCompany != null
              ? "verified"
              : (company?.claimed && "claimed") || (company?.draft && "warning");
        if (status == "warning" || status == "listing") {
          try {
            const res = await checkworldboxStatus({
              companyID: id,
              userID: userInfo?.individual[0]?.userID,
            });
            if (res?.data?.status === "COMPLETED") {
              setWorldboxStatus("available");
            }
          } catch (error) {
          }
        } else {
          setWorldboxStatus("available");
        }

        try {
          const res = await getPurchaseDetailsStatus({
            companyID: id,
            userID: userInfo?.individual[0]?.userID,
            token: token
          });

          let purchaseData = ""
          if (res?.data?.purchase?.purchaseType === "Subscription" && res?.data?.purchase?.purchaseID) {
            setPersonalPurchase(true);
          }
          if (res?.data?.enterprise?.purchaseID) {
            purchaseData = {
              purchaseID: res?.data?.enterprise?.purchaseID,
              companyID: res?.data?.enterprise?.companyID,
              planID: res?.data?.enterprise?.planID,
              purchaseDate: res?.data?.enterprise?.purchaseDate,
              expireDate: res?.data?.enterprise?.expireDate,
              purchaseType: res?.data?.enterprise?.purchaseType,
              wb_id: res?.data?.enterprise?.wb_id,
              userID: res?.data?.enterprise?.userID,
              status: res?.data?.enterprise?.status
            }
          } else if (res?.data?.purchase?.purchaseID) {
            purchaseData = res?.data?.purchase;
          } else {
            purchaseData = res?.data?.enterprise
          }
          setgetPurchaseDetails(purchaseData);
        } catch (error) {
        }
      }
    })();
  }, [company, userInfo, shareUrl, triggerPurchaseApi]);

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  useEffect(() => {
    if (
      company &&
      company?.verifiedCompany !== null &&
      company?.verifiedCompany !== undefined
    ) {
      const data = company?.verifiedCompany;
      let isVerified = isObjectEmpty(data);
      if (!isVerified) {
        const today = new Date();
        const isTodayWithinRange = isWithinInterval(today, {
          start: parseISO(data.date_of_verification),
          end: parseISO(data.date_of_verification_exp)
        });
        isVerified = !isTodayWithinRange;
      }
      setVerifiedCompany(!isVerified);
    }
  }, [company]);

  useEffect(() => {
    Countries.filter((county) => {
      if (
        county.code ===
        (trevexId ? company?.country_code : company?.company?.countrycode)
      ) {
        setFlag(county?.file_url);
      }
    });
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await GetCompanyuserList({ data: { id }, token });

        if (data) setUsersData(data);
      } catch (error) {
      }
    })();
  }, [GetCompanyuserList, id, token, updateList]);
  //company register

  const [createCompany, { isLoading: companyCreating }] =
    useCreateCompanyMutation();
  const [createOrderWorldBox, { isLoading: orderCreating }] =
    useCreateWorldBoxOrderMutation();
  const [createFollow, { isLoading }] = useCreateCompanyFollowMutation();

  const handleModalToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleClaimCompany = (e) => {
    e.preventDefault();
    ReactGA.event({
      category: 'Claim this Business',
      action: 'Clicked on Claim this Business',
      label: `Clicked on Claim this Business`
    });
    if (isLoggedIn) {
      navigate(
        `/claim/${trevexId ? company?.companyID : company?.company?.win}`
      );
    } else {
      localStorage.setItem("lastVisited", `/claim/${trevexId ? company?.companyID : company?.company?.win}`)
      navigate("/login");
    }
  };

  const { data: worldboxData } = useGetCompanyNewQuery(
    { id: company?.wb_win },
    { skip: !company }
  );

  useEffect(() => {
    refetch()
  }, [userInfo])

  const [getPurchaseDetails, setgetPurchaseDetails] = useState();

  const todayDate = formatDateToISO(new Date());
  const currentDate = new Date(todayDate);
  const purchaseSubScriptionStartDateStr = getPurchaseDetails?.purchaseDate;
  const purchaseSubScriptionEndDateStr = getPurchaseDetails?.expireDate;
  const purchaseSubScriptionStartDate = new Date(
    purchaseSubScriptionStartDateStr
  );
  let purchaseEnd;
  const purchaseSubScriptionEndDate = new Date(purchaseSubScriptionEndDateStr);
  const purchaseSubScriptionValid =
    currentDate >= purchaseSubScriptionStartDate &&
    currentDate <= purchaseSubScriptionEndDate;

  let subType = getPurchaseDetails?.purchaseType;

  const subscriptionEndDate = data?.individualSubscription[0]?.date_of_end;
  const subscriptionStartDate = data?.individualSubscription[0]?.date_of_start;
  const isSubscriptionValid =
    new Date(subscriptionEndDate) >= new Date(todayDate);
  const subscriptionID = data?.individualSubscription[0]?.subscriptionID;
  const currentURL = window.location.href;
  const parts = currentURL.split("/");
  const currentCompanyId = parts[parts.length - 1];

  // TIP-504 — endorsement view is member-gated on the VIEWER's active company.
  // The backend (TIP-492) returns the full `endorsements` list to an active
  // member (and writes an audit row) or a teaser `endorsement_count` to anyone
  // else. We surface the real count to members and the prompt to non-members.
  const activeCompanyId = useSelector(selectActiveCompanyId);
  const { data: endorsementView } = useGetEndorsementsQuery(
    { companyId: currentCompanyId, actingCompanyId: activeCompanyId, token },
    { skip: !currentCompanyId || !token }
  );
  // Map the two-way-gated response to a display mode:
  //   member viewer of a member company -> "member" (+ real count)
  //   non-member viewer of a member company with endorsements -> "prompt" (no count)
  //   target not a member / none -> no endorsement element
  let endorsementMode = null;
  let endorsementCount = 0;
  if (endorsementView && endorsementView.public !== false) {
    if (Array.isArray(endorsementView.endorsements)) {
      endorsementCount = endorsementView.endorsements.length;
      endorsementMode = endorsementCount > 0 ? "member" : null;
    } else if (endorsementView.teaser && endorsementView.has_endorsements) {
      endorsementMode = "prompt";
    }
  }

  // TIP-507 — member companies can request the free Verified badge from the
  // profile CTA (same verify-request endpoint as the dashboard, TIP-491).
  const [requestVerification, { isLoading: isRequestingVerification }] =
    useRequestVerificationMutation();
  const [verifyRequested, setVerifyRequested] = useState(false);
  const handleGetVerified = async () => {
    try {
      await requestVerification({ companyID: currentCompanyId, token }).unwrap();
      setVerifyRequested(true);
      CommonToast.success("Verification requested — our team will review it shortly.");
    } catch (err) {
      CommonToast.error(
        err?.data?.detail || "Couldn't request verification. Please try again."
      );
    }
  };
  const companyViewed = data?.individualSubscription;
  const companyIDs = companyViewed?.map((i) =>
    i?.CompanyViewed?.map((view) => view?.company_viewed_detailsID?.companyID)
  );
  const isCompanyIDPresent = companyIDs?.includes(currentCompanyId);

  if (currentCompanyId?.startsWith("TRX")) {
    var isTrevexCompany = true;
  } else {
    var isTrevexCompany = false;
  }
  let requestIndividual = data?.requestIndividual || [];

  useEffect(() => {
    if (isSubscriptionValid) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 30);
      purchaseEnd = formatDateToISO(currentDate);
    }
  }, [currentDate, isSubscriptionValid, worldboxData]);

  useEffect(() => {
    for (let i = 0; i < requestIndividual?.length; i++) {
      if (
        requestIndividual[i]?.request_type == "Verify Company" &&
        requestIndividual[i]?.companyID?.companyID == id
      ) {
        setRequestIndividualStatus(requestIndividual[i]?.status);
      }
    }
  }, [requestIndividual]);

  useEffect(() => {
    const thisCompanyDetails = companyViewed?.filter(
      (item) => item?.company_viewed_detailsID?.companyID === currentCompanyId
    );

    if (thisCompanyDetails && thisCompanyDetails.length !== 0) {
      setCompSubsEnd(thisCompanyDetails[0]?.company_viewed_detailsID?.end_date);
    }

    if (isSubscriptionValid) {
      if (isTrevexCompany) {
      } else {
        setNotTrevexCompany(true);
      }
    }
  }, [
    companyViewed,
    companyViewedDetails,
    currentCompanyId,
    isSubscriptionValid,
    isTrevexCompany,
    subscriptionEndDate,
    subscriptionID,
    token,
  ]);

  const handlePurchased = async (type = 'credit') => {
    setCreditType(type)
    const profileStartDate = formatDateToISO(currentDate);
    let customerreference;
    if (!formData.name.trim()) {
      customerreference = 'No reference data provided';
    } else {
      customerreference = `Name: ${formData.name},
      Designation: ${formData.designation},
      Email: ${formData.email},
      Contact: ${formData.contactNumber || 'N/A'},`;
    }

    const purchasedata = {
      planID: subscriptionID,
      purchaseDate: format(new Date(), 'yyyy-MM-dd'), // yyyy-mm-dd
      expireDate: format(addMonths(new Date(), 1), 'yyyy-MM-dd'),     // yyyy-mm-dd
      userID: userInfo?.individual[0]?.userID,
      companyID: currentCompanyId,
      purchaseType: "Subscription",
      ...(type === 'enterprise' && { enterpriseID: selectedEnterprise?.id, customerreference: customerreference, })
    };
    const res = await createPurchaseDetails({
      data: purchasedata,
      token
    });
    if (res.data) {
      let status =
        company?.companyID === undefined
          ? "listing"
          : company?.verifiedCompany != null
            ? "verified"
            : (company?.claimed && "claimed") || (company?.draft && "warning");
      if (status != "listing" && status != "warning") {
        if (!isFollowed) {
          if (trevexId) {
            const response = await createFollow({
              data: {
                companyID: company?.companyID,
                userID: userInfo?.individual[0]?.userID,
              },
              token,
            }).unwrap();
          }
        }
      }
      let postData = {};
      let win_no;
      if (status === "listing") {
        win_no = company?.company.win;
        postData = {
          win_number: win_no,
          companyID: id,
          userID: userInfo?.individual[0]?.userID,
          customerreference: customerreference,
        };
      } else if (status === "warning") {
        win_no = company?.wb_win;
        if (win_no == null) {
          if (company?.companyAddress?.length <= 0) {
            postData = {
              companyID: id,
              companyname: company?.registered_company_name,
              address1: company?.country_code,
              city: company?.country_code,
              countrycode: company?.country_code,
              currency: "USD",
              userID: userInfo?.individual[0]?.userID,
              customerreference: customerreference,
            };
          } else {
            postData = {
              companyID: id,
              companyname: company?.registered_company_name,
              address1:
                company?.companyAddress[0]?.company_address_detailsID
                  ?.address_line_1 +
                " " +
                company?.companyAddress[0]?.company_address_detailsID
                  ?.address_line_2 +
                " " +
                company?.companyAddress[0]?.company_address_detailsID?.area +
                " " +
                company?.companyAddress[0]?.company_address_detailsID?.city +
                " " +
                company?.companyAddress[0]?.company_address_detailsID?.state,
              city: company?.companyAddress[0]?.company_address_detailsID?.state,
              countrycode:
                company?.companyAddress[0]?.company_address_detailsID?.country,
              currency: "USD",
              userID: userInfo?.individual[0]?.userID,
              customerreference: customerreference,
            };
          }
        } else {
          postData = {
            win_number: win_no,
            companyID: id,
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference,
          };
        }
      }
      if (type === 'credit' && (status === "listing" || status === "warning")) {
        //DONE: add Purchase in the createOrderWorldBox API request, 
        //      This PUrchase ID you will get from createPurchaseDetails res this is called on line 473
        //     Related changes are in backend in views.py > WordboxOrderCreateView  line 1688
        try {
          const data = await createOrderWorldBox({
            data: res?.data?.purchaseID ? { ...postData, purchaseID: res?.data?.purchaseID } : postData,
            token,
          }).unwrap();
          if (data) {
          }
        } catch (error) {
        }
      }

      localStorage?.removeItem("payasyougoCompanyID");
      setCreditNoticePopup(false);
      setPurchasedCompanyPopup(true);
    } else if (res.error) {
      CommonToast?.error(res.error.data.error ?? 'Purchase failure')
    }
  };
  const handleGetCompany = async () => {
    localStorage.removeItem("UpgradePlan");

    const jsonData = JSON.stringify(currentCompanyId);
    localStorage.setItem("payasyougoCompanyID", jsonData);
    let status =
      company?.companyID === undefined
        ? "listing"
        : company?.verifiedCompany != null
          ? "verified"
          : (company?.claimed && "claimed") || (company?.draft && "warning");
    localStorage.setItem("paycompanyStatus", status);

    if (subscriptionActive?.no_of_profile_views >= 1 || userEnterprise?.length > 0) {
      setCreditNoticePopup(true);
    } else if (!verifiedCompany && token) {
      window.scrollTo(0, 0);
      return navigate("/plans", {
        state: { company_id: id },
      });
    } else if (!verifiedCompany && !token) {
      window.scrollTo(0, 0);
      // alert("came to /login?guest=true")
      // return navigate("/login?guest=true", {
      //   next: "/plans",
      //   state: { company_id: id },
      // });
      return navigate("/plans", {
        state: { company_id: id },
      });
    }
    else {
      window.scrollTo(0, 0);
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      navigate("/plans");
    }
  };

  const [isCurrentCompFollowID, setIsCurrentCompFollowID] = useState(null);

  useEffect(() => {
    const foundID = userInfo?.companyFollow?.find(
      (entry) => entry.companyID?.companyID === company?.companyID
    )?.company_follow_ID;
    setIsCurrentCompFollowID(foundID || null);
  }, [userInfo, company]);

  const [deleteFollow, { isLoading: deleteLoading, isError: deleteError }] =
    useDeleteCompanyFollowMutation();

  const handleFollowCompany = async () => {
    if (token == null) {
      navigate("/login");
    } else {
      if (!isFollowed) {
        if (trevexId) {
          const res = await createFollow({
            data: {
              companyID: company?.companyID,
              userID: userInfo?.individual[0]?.userID,
            },
            token,
          }).unwrap();

          if (res && res?.company_follow_ID) {
            setIsCurrentCompFollowID(res?.company_follow_ID);
          }
        } else {
          try {
            const data = await createCompany({
              data: {
                registered_company_name: company?.company?.name,
                country_code: company?.company?.countrycode,
                wb_win: company?.company?.win,
              },
              token,
            }).unwrap();

            if (data) {
              const res = await createFollow({
                data: {
                  companyID: data?.data?.companyID,
                  userID: userInfo?.individual[0]?.userID,
                },
                token,
              }).unwrap();

              setIsCurrentCompFollowID(res?.company_follow_ID);

              if (res) {
                const trxid = data?.data?.companyID;
                window.location = trxid;
              }
            }
          } catch (error) {
          }
        }
      } else {
      }
      setIsFollowed((prevIsFollowed) => !prevIsFollowed);
    }
  };

  const handleUnfollowCompany = async () => {
    try {
      const res = await deleteFollow({
        id: isCurrentCompFollowID,
        token,
      }).unwrap();
    } catch (error) {
    }
    setIsCurrentCompFollowID(null);
  };

  const handleMoreClick = () => {
    if (moreButtonOptionRef.current) {
      const screenWidth = window.innerWidth;
      const rect = moreButtonOptionRef.current.getBoundingClientRect();

      if (screenWidth < 600) {
        if (screenWidth - rect.right < screenWidth / 2) {
          setMoreOptionPosition('towardsLeft')
        }
      }
    }

    setIsMoreOpen((val) => !val);
  };

  const createWorldBoxOrder = async () => {
    localStorage.removeItem("UpgradePlan");
    let customerreference;
    if (!formData.name.trim()) {
      customerreference = 'No reference data provided';
    } else {
      customerreference = `Name: ${formData.name},
Designation: ${formData.designation},
Email: ${formData.email},
Contact: ${formData.contactNumber || 'N/A'},`;
    }
    let status =
      company?.companyID === undefined
        ? "listing"
        : company?.verifiedCompany != null
          ? "verified"
          : (company?.claimed && "claimed") || (company?.draft && "warning");
    let postData = {};
    let win_no;
    if (status === "listing") {
      win_no = company?.company.win;
      postData = {
        win_number: win_no,
        companyID: id,
        userID: userInfo?.individual[0]?.userID,
        customerreference: customerreference
      };
    } else if (status === "warning") {
      win_no = company?.wb_win;
      if (win_no == null) {
        if (company?.companyAddress?.length <= 0) {
          postData = {
            companyID: id,
            companyname: company?.registered_company_name,
            address1: company?.country_code,
            city: company?.country_code,
            countrycode: company?.country_code,
            currency: "USD",
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference
          };
        } else {
          postData = {
            companyID: id,
            companyname: company?.registered_company_name,
            address1:
              company?.companyAddress[0]?.company_address_detailsID
                ?.address_line_1 +
              " " +
              company?.companyAddress[0]?.company_address_detailsID
                ?.address_line_2 +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.area +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.city +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.state,
            city: company?.companyAddress[0]?.company_address_detailsID?.state,
            countrycode:
              company?.companyAddress[0]?.company_address_detailsID?.country,
            currency: "USD",
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference,
          };
        }
      } else {
        postData = {
          win_number: win_no,
          companyID: id,
          userID: userInfo?.individual[0]?.userID,
          customerreference: customerreference
        };
      }
    }
    if (status === "listing" || status === "warning") {
      setIsContinue(true)
      localStorage.setItem("createWorldbox", true);
      localStorage.setItem("worldboxData", JSON.stringify(postData));
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      handleGetCompanyPopup();
    } else {
      setIsContinue(true)
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      handleGetCompanyPopup();
      if (token) {
        window.scrollTo(0, 0);
        return navigate("/plans", {
          state: { company_id: id },
        });
      } else if (!token) {
        window.scrollTo(0, 0);
        // return navigate("/login?guest=true", {
        //   next: "/plans",
        //   state: { company_id: id },
        // });
        return navigate("/plans", {
          state: { company_id: id },
        });
      }
    }
  };

  const handleRoleManageClick = () => {
    setIsMoreOpen(false);
    setRoleManageOpen((val) => !val);
  };

  const handleInviteChange = (event) => {
    const { name, value } = event.target;
    setInviteData({ ...inviteData, [name]: name === "email" ? value?.toLowerCase() : value });
  };

  const handleInviteSubmit = async () => {
    try {
      const user = userInfo;
      const data = await userInvite({
        data: { ...inviteData, company_id: id },
        token,
      }).unwrap();
      if (data) {
        CommonToast.success(`Invitation sent to: ${inviteData.email}`);
        setUpdateList(!updateList)
        setInviteData({ email: "", role: "AD", name: "" });
      }
    } catch (error) {
      CommonToast.error(error?.data?.status || error?.data?.error || error?.data?.role?.length >= 0 && error?.data?.role[0] || error?.status)
    }
  };

  const handleMoreButton = (tag) => {
    if (tag === "Manage Roles") { handleRoleManageClick(); }
    else if (tag === "Save Company as PDF") { exporttoPDF() }
    else if (tag === "Email Prefenences") {

    }
  };

  const handleCopy = () => {
    company_urlRef.current.select();
    setCopyText("Copied")
    document.execCommand("copy");
  };
  const handleMouseDown = () => {
    setCopyText("Copy")
  }
  const handleRefresh = () => {
    window?.location?.reload();
  };
  const paynowRedirect = () => {
    window.scrollTo(0, 0);
    navigate("/plans", { state: id });
  }

  const sanitizeFilename = (name) => {
    return name
      ?.replace(/[^a-zA-Z0-9._-]/g, '_')
      ?.replace(/_+/g, '_')
      ?.substring(0, 100)
      || 'download';
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(`/api/company/export-pdf/${id}/pdf/`, {
        method: 'GET',
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const safeFileName =
        sanitizeFilename(company?.registered_company_name) || 'document';

      const link = document.createElement('a');
      link.href = url;
      link.download = `${safeFileName}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url); // 🔥 important

      setexporttoPDF(false);
      CommonToast.success(`PDF Download Started`);
    } catch (error) {
      CommonToast.error(`Error downloading PDF`);
    }
  };

  const exporttoPDF = async () => {
    try {
      if (!PDFExporting) {
        setexporttoPDF(true);
        setIsMoreOpen(false);
        CommonToast.info(`PDF Generation started, It will be download soon.`);
        handleDownload();
      }
    } catch (error) {
      setexporttoPDF(false);
      CommonToast.error(`PDF Export Failed`);
    }
  }

  const handleRoleChange = async (e, user) => {
    const requestRoleData = {
      id: user?.id,
      role: e.target.value,
    }

    try {
      const roleUpdateResponse = await userRoleUpdate({ data: requestRoleData, token }).unwrap();
      if (roleUpdateResponse) {
        CommonToast.success(roleUpdateResponse.status);
        setUpdateList(!updateList)
      }
    } catch (error) {
      CommonToast.error(`Something went wrong`);
    }
  }

  const handleUserDelete = async (e, user) => {
    const requestRoleData = {
      id: user?.id,
    }
    try {
      const roleUpdateResponse = await userRoleDelete({ data: requestRoleData, token }).unwrap();
      if (roleUpdateResponse) {
        CommonToast.success(roleUpdateResponse.status);
        setUpdateList(!updateList)
      }
    } catch (error) {
      CommonToast.error(`Something went wrong`);
    }
  }

  const handleVerifyProfile = () => {
    (verifiedCompany || company?.claimed)
      ? handleGetCompany()
      : createWorldBoxOrder()
  }

  const navigateToBilling = (plan) => {
    if (token != undefined) {
      navigate("/plans/paymentdetails", {
        state: {
          planDetails: plan,
          company_id: id,
        },
      });
    } else {
      localStorage.setItem("lastVisited", `/search/${id}`);
      localStorage.setItem("slug", plan.slug);
      navigate("/login")
    }
  }

  const buyFullProfile = () => {
    const plan = {
      title: "Pay-as-you-go",
      mode: "one-time",
      slug: "pay-as-you-go",
      subsCharge: 79,
      talkToSales: true,
      Features: [
        "1 profile views for 1 month",
        "full profile access for 1 month.",
      ],
    };
    navigateToBilling(plan)
  }

  useEffect(() => {
    if (getDetailsClicked) {
      handleVerifyProfile();
      setGetDetailsClicked(!getDetailsClicked);
    }
  }, [getDetailsClicked])

  const buttonContent = (
    <>
      {!isMobile && <Verified />}
      Access Business
      {isMobile && <RightArrow className="w-[12px] h-[12px]" />}
    </>
  );

  const profileStatus = company.profileProgress === 1 ? "Basic" : (company.profileProgress === 2) ? "Intermediate" : (company.profileProgress === 3) ? "Advanced" : (company.profileProgress === 4) ? "Completed" : "Basic";
  // Render the button based on conditions
  const renderButton = () => (
    <Button
      onClick={handleClaimCompany}
      // disabled={isMobile}
      classes={`rounded flex items-center gap-2 py-2 px-3 sm:py-2 sm:px-3 md:px-6 md:text-f16 text-[12px] font-semibold bg-white text-link border border-link`}
    >
      {buttonContent}
    </Button>
  );

  const isOptionDisabled = (optionName) => {
    if (optionName === "Save Company as PDF") {
      return !id?.startsWith("TRX") || (!purchaseSubScriptionValid && !role);
    } else if (optionName === "Manage Roles") {
      return role === "ED" || purchaseSubScriptionValid;
    }
    return false;
  };

  const areBothOptionsDisabled = () => {
    return isOptionDisabled("Save Company as PDF") && isOptionDisabled("Manage Roles");
  };

  const checkStates = company?.companyAddress?.[0]?.company_address_detailsID?.state || company?.company?.county || company?.company?.city || worldboxData?.company?.county || worldboxData?.company?.city || null;
  const countryName = company?.company?.country || (company?.country_code && getCountryByCode(company?.country_code)) || null;
  // const seperatedEnterpriseData = userEnterprise?.reduce(
  //   (acc, item) => {
  //     if (item.enterprise_type === "PARTNER_PROGRAM") {
  //       acc.partner.push(item);
  //     } else {
  //       acc.normal.push(item);
  //     }
  //     return acc;
  //   },
  //   { normal: [], partner: [] }
  // );

  // derive flags above your return
  const isClaimedCompany =
    companyArr.includes(id) && companyDet[0]?.claimed === true;

  const hasSubscription = purchaseSubScriptionValid;
  const worldboxAvailable = WorldboxStatus === "available";
  const hasAnyRole = Boolean(role);

  // this matches the last `else` where you show "Buy Full Profile"
  const showBuyFullProfileButton = !isClaimedCompany && !hasSubscription;

  // Add to enterprise visible only when:
  // - user has enterprise data
  // - we're in the "Buy Full Profile" state
  // - user has NO role
  // - profile not purchased (covered by showBuyFullProfileButton)
  const EnterpriseButtonText = getPurchaseDetails?.status ? convertLetterCase(getPurchaseDetails.status.split("_").join(" "), "titlecase") : "Add to Enterprise"
  // const checkPurchaceDetailsForEnterprise = 
  const showAddToEnterprise = userEnterprise?.length > 0 && !hasAnyRole;

  // TIP-505 — prefer the backend membership-aware ladder (profile_status) so a
  // member renders as the gold "member" banner (not "claimed"). Fall back to
  // the legacy client-side signals when profile_status isn't present.
  const statusData =
    company?.profile_status === "verified" ? "verified"
      : company?.profile_status === "member" ? "member"
        : company?.profile_status === "claimed" ? "claimed"
          : company?.profile_status === "listed" ? "listing"
            : company?.companyID === undefined ? "listing"
              : company?.verifiedCompany != null ? "verified"
                : (company?.claimed && "claimed") || (company?.draft && "warning")


  return (
    <div className="">
      <Card classes="bg-white rounded-lg">
        {isOpen && (
          <Modal modalHandle={handleModalToggle}>
            <LockCard paynow={() => paynowRedirect()} />
          </Modal>
        )}
        <div>
          <div>
            <img
              className="w-full max-h-52 object-fill"
              src={company?.banner ? company?.banner : CompanyBanner}
              alt="banner"
            />
            <VerifiedByTrevex
              status={statusData}
              logo={company?.logo}
            />
          </div>
          <div className=" mx-auto md:p-7 p-4">
            <div className="grid sm:grid-cols-8 grid-cols-4 sm:gap-4 sm:pb-4">
              <div className="hidden sm:block col-span-1 relative">
                {!company?.logo ? (
                  <ProfileImage className="sm:h-auto h-16 sm:w-auto w-16" />
                ) : (
                  <>
                    <img
                      className="sm:h-auto h-16 sm:w-auto w-16"
                      src={company?.logo}
                      alt="Company Logo"
                    />
                  </>
                )}
                {company?.verifiedCompany != null && (
                  <div className="absolute top-0 right-[15px] sm:right-0 transform -translate-y-2 translate-x-2">
                    <img src={RoundedVerifyFilled} className="w-7 h-7" />
                  </div>
                )}
              </div>
              <div className="sm:col-span-5 col-span-4">
                <div className="flex justify-between items-start mt-5 sm:mt-0">
                  <h1 className="text-primary md:text-f24 sm:text-f18 text-[14px] font-bold text-left flex sm:gap-4 gap-1 items-start justify-start">
                    <span className="w-full sm:max-w-lg pr-1">
                      {trevexId
                        ? company?.registered_company_name
                        : company?.company?.name}
                    </span>

                  </h1>
                  <div className="block sm:hidden">
                    <CompanySocialIcons
                      company={company}
                      checkURL={checkURL}
                      setIsShareModalOpen={setIsShareModalOpen}
                      setShareURL={setShareURL}
                    />
                  </div>
                </div>
                <p className="text-secondarytwo flex items-center justify-start gap-2 mt-3 sm:my-5 md:my-3 text-left w-fit font-semibold rounded-2xl">
                  <div className="flex items-center h-full">
                    {flag && (
                      <img
                        src={`${flag}`}
                        alt="country flag"
                        width="20px"
                      // height="25px"
                      />
                    )}
                  </div>
                  <p className="md:text-f18 text-f12 countrystate">
                    <span>
                      {checkStates ? convertLetterCase(checkStates, 'titlecase') + ", " : ""}
                    </span>
                    <span>{convertLetterCase(countryName, 'titlecase')}</span>
                  </p>
                </p>
                {!isMobile && <div className="flex items-center justify-start mt-3 gap-5">
                  {company?.number_of_employees && (
                    <div className="flex items-center">
                      <GroupUser />
                      <span className="ml-1 font-semibold text-dHeading2 text-f14">
                        {company?.number_of_employees + " employees"}
                      </span>
                    </div>
                  )}
                  {company?.date_of_establishment && (
                    <div className="flex items-center">
                      <Calender />
                      <span className="ml-1 font-semibold text-dHeading2 text-f14">
                        Established on{" "}
                        {formatDateWithOrdinal(company?.date_of_establishment)}
                      </span>
                    </div>
                  )}
                </div>}
              </div>
              {isMobile && <div className="flex sm:flex-col justify-between my-1 col-span-4">
                {company?.number_of_employees && (
                  <div className="flex items-center w-[60%]">
                    <GroupUser />
                    <span className="ml-1 font-semibold text-[#777F7F] text-[12px]">
                      {company?.number_of_employees} employees
                    </span>
                  </div>
                )}
                {company?.date_of_establishment && <div className="flex items-center w-[40%]">
                  <Calender className="w-6 h-6 mt-1 mx-1" />
                  <p className="ml-1 font-semibold text-[#777F7F] text-[12px] text-left">
                    Established on{" "}
                    {formatDateWithOrdinal(company?.date_of_establishment)}
                  </p>
                </div>}
              </div>}
              <div className="flex flex-col justify-start items-start sm:col-span-2 col-span-4 sm:block flex sm:items-center">
                <div className="hidden sm:block">
                  <CompanySocialIcons
                    company={company}
                    checkURL={checkURL}
                    setIsShareModalOpen={setIsShareModalOpen}
                    setShareURL={setShareURL}
                  />
                </div>
                {/* <div className="flex gap-2 justify-start sm:justify-end">
                  {company?.linkedin && (
                    <SocialIcons
                      link={checkURL(company?.linkedin)}
                      classes={`sm:w-auto w-1/2`}
                      targetdata={`_blank`}
                    >
                      <Linkedin className="sm:h-auto h-7" />
                    </SocialIcons>
                  )}
                  {company?.twitter && (
                    <SocialIcons
                      link={checkURL(company?.twitter)}
                      classes={`sm:w-auto w-1/2`}
                      targetdata={`_blank`}
                    >
                      <Twitter className="sm:h-auto h-7" />
                    </SocialIcons>
                  )}
                  {company?.instagram && (
                    <SocialIcons
                      link={checkURL(company?.instagram)}
                      classes={`sm:w-auto w-1/2`}
                      targetdata={`_blank`}
                    >
                      <Instagram className="sm:h-auto h-7" />
                    </SocialIcons>
                  )}
                  {company?.facebook && (
                    <SocialIcons
                      link={checkURL(company?.facebook)}
                      classes={`sm:w-auto w-1/2`}
                      targetdata={`_blank`}
                    >
                      <Facebook className="sm:h-auto h-7" />
                    </SocialIcons>
                  )}
                  {company?.website && (
                    <SocialIcons
                      link={checkURL(company?.website)}
                      classes={`sm:w-auto w-1/2`}
                      targetdata={`_blank`}
                    >
                      <Global className="sm:h-auto h-7" />
                    </SocialIcons>
                  )}
                  <SocialIcons
                    classes={`sm:w-auto w-1/2`}
                  >
                    <Share
                      onClick={() => { setIsShareModalOpen(true); setShareURL(window.location.href) }}
                      className="sm:h-auto h-7"
                    />
                  </SocialIcons>

                </div> */}
                <div className="flex justify-end items-center w-full">
                  {typeof (company.profileProgress) === 'number' && <div className="w-[60%] flex justify-start sm:justify-end">
                    <p className="text-[12px] text-right text-[#3C4848] py-1 px-2 rounded-[4px] block sm:hidden boxShadowProfile">Profile Completion: <span className="font-semibold">{" " + profileStatus}</span></p>
                    {(company?.verifiedCompany || company?.claimed) && <div className="w-[240px] hidden sm:block"><p className="mt-4 text-[13px] font-bold text-right">Profile Completion: <span className="font-normal">{" " + profileStatus}</span></p>
                      <div className="hidden sm:flex justify-end items-center h-[40px]">{
                        pgColors.map((color, i) => {
                          return (
                            <div className="flex items-center" key={color}><div style={{ backgroundColor: color }} className={`w-[2rem] sm:3rem md:w-[3.5rem] lg: w-[5rem] h-1 ${company.profileProgress !== i + 1 ? 'border-x' : 'border-l'}`}></div>{(company.profileProgress === i + 1 || company.profileProgress === 0) && <CommonTooltip id={'progressTooltip'} content={profileStatus}><BrownCheck /></CommonTooltip >}</div>)
                        })}</div></div>}
                  </div>}
                  <div className="text-secondarytwo flex justify-start gap-2 sm:mt-3 w-[40%] sm:hidden">
                    {
                      (role || purchaseSubScriptionValid) &&
                      company?.endorsements > 0 && (
                        <div style={{ "color": "#2c5369" }}>
                          {typeof company.endorsements === 'number' ? (
                            companyType === 'verified' && company?.endorsements > 0 ? (
                              <div className='flex items-center gap-1 px-3 py-1 rounded-full bg-[#E6F1F8] text-[#0077B5]'>
                                {isMobile && <EndorsementIcon className='w-[13px] h-[10px]' />}
                                {!isMobile && <EndorsementIcon className='sm:w-[20px] sm:h-[20px]' />}
                                <p className="flex mx-0 sm:mx-2 font-semibold text-[14px] sm:text-f16 gap-[2px]">{company.endorsements > 0 && company.endorsements} <span title="Payment Timeliness"></span> {company.endorsements === 1 ? "Endorsement" : "Endorsements"}</p>
                                <CommonTooltip styles={{ backgroundColor: '#EBF0F3', color: 'black' }} id={'help-tooltip'} htmlContent={
                                  <div className='max-w-[250px]'>
                                    <p className='text-[16px] font-bold'>What are Payment Timeliness Endorsements?</p>
                                    <p className='text-left text-[12px]'>These endorsements showcase a company's reliability in settling payments through positive feedback from endorsers, highlighting their consistent on-time payment history.</p>
                                  </div>
                                }>
                                  {!isMobile && <GrayHelp className='w-[20px] h-[20px]' />}
                                </CommonTooltip>
                              </div>
                            ) : (
                              <div className='flex items-center gap-1 px-3 py-1 rounded-full bg-[#E6F1F8] text-[#0077B5]'>
                                {isMobile && <EndorsementIcon className='w-[13px] h-[10px]' />}
                                <p className="flex mx-0 sm:mx-2 font-semibold text-[14px] sm:text-f16 gap-[2px]">0 <span title="Payment Timeliness"></span> Endorsement</p>
                                <CommonTooltip styles={{ backgroundColor: '#EBF0F3', color: 'black' }} id={'help-tooltip'} htmlContent={
                                  <div className='max-w-[250px]'>
                                    <p className='text-[16px] font-bold'>Why Endorse?</p>
                                    <p className='text-left text-[12px]'>Endorsements are powerful affirmations from trusted sources that validate the quality and reliability of a product, service, or individual.</p>
                                  </div>
                                }>
                                  {!isMobile && <GrayHelp className='w-[20px] h-[20px]' />}
                                </CommonTooltip>


                                {/* <p className={`font-semibold text-f16`}><span className='text-[10px]'>000</span> Endorsement</p>
                              <CommonTooltip styles={{ backgroundColor: '#EBF0F3', color: 'black' }} id={'help-tooltip'} htmlContent={
                                <div className='max-w-[250px]'>
                                  <p className='text-[16px] font-bold'>Why Endorse?</p>
                                  <p className='text-left text-[12px]'>Endorsements are powerful affirmations from trusted sources that validate the quality and reliability of a product, service, or individual.</p>
                                </div>
                              }>
                                {!isMobile && <GrayHelp className='w-[20px] h-[20px]' />}
                              </CommonTooltip> */}
                              </div>
                            )
                          ) : (
                            <p className="md:text-f16 text-f12 font-bold"></p>
                          )}
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>

            {/* {company?.industry && (
              <div className="flex py-1 sm:px-3 px-2 rounded-2xl items-center sm:mt-0 mt-3">
                <Rocket className="sm:w-auto w-16" />
                <p className="ml-3 text-secondarytwo tracking-subheading font-semibold text-f12 sm:text-f16 truncate">
                  {toSentenceCaseCP(industry?.sector)}
                  {industry?.sub_industry && "  |  "}
                  {toSentenceCaseCP(industry?.sub_industry)}
                </p>
              </div>
            )} */}
            <hr className="mt-2" />
            <div className="flex flex-wrap gap-y-2 gap-4 mt-4 md:justify-between md:flex-row sm:flex-row">
              <div
                className="flex md:justify-between justify-start  sm:gap-4 gap-2"
                ref={moreOptionRef}
              >
                {companyExists ? null : (
                  <>
                    <Button
                      onClick={
                        isCurrentCompFollowID === null
                          ? handleFollowCompany
                          : handleUnfollowCompany
                      }
                      classes={`${isCurrentCompFollowID
                        ? "text-link bg-white rounded flex items-center gap-1 sm:gap-2 py-2 px-3 sm:px-3 md:px-6 md:text-f16 border border-link text-[12px] sm:text-f12 font-semibold"
                        : "text-white bg-primary rounded py-2 px-3 flex items-center gap-1 sm:gap-2 px-2 sm:px-3 md:px-6 md:text-f16 text-[12px] font-semibold"
                        }`}
                    >
                      {isCurrentCompFollowID ? (
                        "Unfollow"
                      ) : (
                        <>
                          <Plus className="h-[10px] sm:h-[auto]" /> Follow Business
                        </>
                      )}
                    </Button>
                    {process.env.REACT_APP_CLAIM_RESTRICTION === "true" ? (
                      (company?.country_code?.toLowerCase() === "ae" ||
                        company?.country_code?.toLowerCase() === "uae" ||
                        company?.company?.country?.toLowerCase() === "united arab emirates") && renderButton()
                    ) : (
                      renderButton()
                    )}

                  </>
                )}
                <div className="relative">
                  <div ref={moreButtonOptionRef}>
                    <Button
                      onClick={handleMoreClick}
                      classes={!userInfo || (!role && !purchaseSubScriptionValid) || !company?.companyID?.startsWith("TRX") ? "hidden" : `rounded flex items-center gap-2 py-2 px-3 sm:px-3 sm:py-2 sm:px-3 sm:text-f12 md:px-6 md:text-f16 text-[12px] font-semibold ${(areBothOptionsDisabled()) ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50" : "text-link bg-white border border-link cursor-pointer"}`}
                      isInvalid={areBothOptionsDisabled()}
                    >
                      {isMobile ? "•••" : "More"}
                    </Button>
                  </div>
                  {isMoreOpen ? (
                    <div className={`min-w-[150px] sm:min-w-[240px] shadow-boxPopup rounded-md mt-2 sm:w-auto w-auto bg-white sm:max-h-84 sm:min-h-fit absolute ${moreOptionPosition === 'towardsLeft' && "left-[-7rem]"} z-10`}>
                      <ul className="overflow-y-auto shadow-boxPopup border-greyFade max-h-36 min-h-36 sm:max-h-64 sm:min-h-fit rounded-md">
                        {moreOptions.map((option) => (
                          <>
                            <button
                              className={`w-full px-4 py-3 hover:bg-[#FFEEEA] flex text-left text-xs hover:bg-[#FFEEEA] ${isOptionDisabled(option.name) ? "cursor-not-allowed bg-gray opacity-50" : "cursor-pointer"}`}
                              role="presentation"
                              disabled={isOptionDisabled(option.name)}
                              onClick={() => handleMoreButton(option.name)}
                              key={option.name}
                            >
                              <img
                                src={option.file_url}
                                width="20px"
                                height="20px"
                                className="mr-2 h-5"
                                alt="hello"
                              />
                              <span className="text-[12px] sm:text-[16px]">{option.name}</span>
                            </button>
                          </>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>
              {/* {userEnterprise?.length > 0 && <EnterpriseAddCompany companyDetails={company} enterpriseData={userEnterprise} />} */}
              <div className="flex md:justify-between justify-start sm:gap-4 gap-2">
                {showAddToEnterprise && (
                  <EnterpriseAddCompany getPurchaseDetails={getPurchaseDetails} EnterpriseButtonText={EnterpriseButtonText} triggerPurchaseApi={triggerPurchaseApi} setTriggerPurchaseApi={setTriggerPurchaseApi} statusData={statusData} companyDetails={company} enterpriseData={userEnterprise} />
                )}

                {isClaimedCompany ? (
                  verifiedCompany ? (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 border text-[12px] font-semibold ${role === "ED"
                        ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50"
                        : "text-success bg-success"
                        }`}
                    >
                      <div style={{ width: "21px", height: "21px" }}>
                        <Verify />
                      </div>
                      Verified
                    </Button>
                  ) : RequestIndividualStatus === "pending" ? (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold ${role === "ED"
                        ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50"
                        : "text-white bg-[#FB512D]"
                        }`}
                    >
                      Verification in progress
                    </Button>
                  ) : RequestIndividualStatus === "Modified" ? (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold ${role === "ED"
                        ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50"
                        : "text-white bg-[#FB512D]"
                        }`}
                    >
                      Modified changes verification in progress
                    </Button>
                  ) : (
                    // TIP-489/507 — owner-only profile CTA: non-member → "Get
                    // Membership" (routes to /membership/:companyId); member →
                    // "Get Verified" (free member-only verify request, TIP-491);
                    // verified → nothing.
                    <ProfileMembershipCta
                      key={companyId}
                      companyId={currentCompanyId}
                      role={role}
                      profileStatus={statusData}
                      onGetVerified={handleGetVerified}
                      verifyRequested={verifyRequested}
                      verifySubmitting={isRequestingVerification}
                    />
                  )
                ) : hasSubscription && worldboxAvailable && personalPurchase ? (
                  <Button
                    isInvalid={hasSubscription}
                    key={companyId}
                    classes="text-primaryText bg-white flex items-center gap-2 rounded py-2 px-3 md:px-6 md:text-f16 border border-primary text-f12 font-semibold"
                  >
                    <p>
                      {subType === "LIFETIME_PARTNER_PROGRAM"
                        ? "Subscribed"
                        : `Subscribed Till : ${getPurchaseDetails?.expireDate}`}
                    </p>
                  </Button>
                ) : hasSubscription && personalPurchase ? (
                  <Button
                    isInvalid={hasSubscription}
                    key={companyId}
                    classes="text-primaryText bg-white flex items-center gap-2 rounded py-2 px-3 md:px-6 md:text-f16 border border-primary text-f12 font-semibold"
                  >
                    <p>Subscription In Progress</p>
                  </Button>
                ) : (
                  <Button
                    key={companyId}
                    onClick={handleVerifyProfile}
                    // onClick={buyFullProfile}
                    classes="text-primaryText bg-white flex items-center gap-2 rounded py-2 px-3 sm:py-2 sm:px-3 md:px-6 text-[12px] md:text-f16 sm:text-f12 font-semibold bg-white border border-primary"
                  >
                    Buy Full Profile
                  </Button>
                )}
              </div>

              {/* <div className="flex md:justify-between justify-start  sm:gap-4 gap-2">
                   {userEnterprise?.length > 0 && <EnterpriseAddCompany companyDetails={company} enterpriseData={userEnterprise} />}
                {companyArr.includes(id) && companyDet[0]?.claimed === true ? (
                  verifiedCompany ? (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 border text-[12px] font-semibold ${role === "ED" ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50" : "text-success bg-success"}`}
                    >
                      <div style={{ width: "21px", height: "21px" }}>
                        <Verify />
                      </div>
                      Verified
                    </Button>
                  ) : RequestIndividualStatus === "pending" ? (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold ${role === "ED" ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50" : "text-white bg-[#FB512D]"}`}
                    >
                      Verification in progress
                    </Button>
                  ) : RequestIndividualStatus === "Modified" ? (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold ${role === "ED" ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50" : "text-white bg-[#FB512D]"}`}
                    >
                      Modified changes verification in progress
                    </Button>
                  ) : (
                    <Button
                      key={companyId}
                      isInvalid={role === "ED"}
                      classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold ${role === "ED" ? "text-white bg-[#A29F9F] border-1 border-[#A29F9F] cursor-not-allowed opacity-50" : "text-white bg-[#FB512D]"}`}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate("/plans/paymentdetails", {
                          state: {
                            planDetails: plansInformation[0],
                            currentCompanyId: currentCompanyId,
                          },
                        });
                      }}
                    >
                      Get Verified
                      <ArrowNext className="w-[18px] sm:w-auto h-[18px] sm:h-auto" />
                    </Button>
                  )
                ) : purchaseSubScriptionValid &&
                  WorldboxStatus == "available" ? (
                  <Button
                    isInvalid={purchaseSubScriptionValid}
                    key={companyId}
                    classes="text-primaryText bg-white flex items-center gap-2 rounded py-2 px-3 md:px-6 md:text-f16 border border-primary text-f12 font-semibold"
                  >
                    <p>{subType === "LIFETIME_PARTNER_PROGRAM" ? "Subscribed": `Subscribed Till : ${getPurchaseDetails?.expireDate}`}</p>
                  </Button>
                ) : purchaseSubScriptionValid ?
                  (
                    <Button
                      isInvalid={purchaseSubScriptionValid}
                      key={companyId}
                      classes="text-primaryText bg-white flex items-center gap-2 rounded py-2 px-3 md:px-6 md:text-f16 border border-primary text-f12 font-semibold"
                    >
                      <p>Subscription In Progress</p>
                    </Button>
                  ) : (
                    <Button
                      key={companyId}
                      onClick={handleVerifyProfile}
                      // disable={isMobile}
                      classes={`text-primaryText bg-white flex items-center gap-2 rounded py-2 px-3 sm:py-2 px-2 sm:px-3 md:px-6 text-[12px] md:text-f16 sm:text-f12 font-semibold bg-white border border-primary`}
                    >
                      Buy Full Profile
                    </Button>

                  )}
              </div> */}
            </div>
          </div>
          {((companyType === "verified" && !role) || companyType === "claimed") && <EndorsementBanner company={company} role={role} companyType={companyType} userInfo={userInfo} trevexId={trevexId} endorsementMode={endorsementMode} endorsementCount={endorsementCount} />}
        </div>
        {
          isShareModalOpen ? (
            <Modal closeButtonClass="absolute top-[-5px] sm:top-0 right-0 p-4 z-10" closeWidth="max-w-[20px] sm:max-w-[40px]" modalHandle={() => setIsShareModalOpen(false)}>
              <div className="w-full sm:w-[200px] md:w-[372px] h-[200px] sm:h-[230px] md:h-[330px] ">
                <div className="flex justify-start pl-2 font-bold text-f12 sm:text-f14 md:text-f16 ">
                  Share company
                </div>
                <div className="relative">
                  <div className="">
                    <div className="grid grid-cols-4 gap-4 justify-around pt-5">
                      <EmailShareButton
                        subject={"Interesting Company Profile on Trevex"}
                        separator=" "
                        body={`Greetings, I thought you might be interested in checking out this company profile I found on Trevex: ${shareUrl}. Let me know your thoughts!`}
                        className="Demo__some-network__share-button"
                      >
                        <Gmail2 className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </EmailShareButton>
                      <WhatsappShareButton
                        url={shareUrl}
                        title={"Hey, I just came across this company on Trevex. Thought you might find it interesting."}
                        separator=""
                        className="Demo__some-network__share-button"
                      >
                        <Whatsapp className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </WhatsappShareButton>
                      <TwitterShareButton
                        url={shareUrl}
                        title={'Post: "Exploring this intriguing company on Trevex! Check out their profile."'}
                        className="Demo__some-network__share-button"
                      >
                        <Twiter2 className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </TwitterShareButton>
                      <FacebookShareButton
                        url={shareUrl}
                        quote={'Post: "Discovering some new companies on Trevex. This one caught my attention."'}
                        className="Demo__some-network__share-button"
                      >
                        <Facebook2 className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </FacebookShareButton>
                    </div>
                    <div className="grid grid-cols-4 gap-4 justify-around py-5">
                      <LinkedinShareButton url={shareUrl} title={`Post: "Came across this company's profile on Trevex. They have some interesting insights"`} className="Demo__some-network__share-button">
                        <Linkdin2 className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </LinkedinShareButton>
                      <TelegramShareButton
                        url={shareUrl}
                        title={'Post: "Check out this company I found on Trevex."'}
                        className="Demo__some-network__share-button"
                      >
                        <Telegram2 className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </TelegramShareButton>
                      <FacebookMessengerShareButton
                        url={shareUrl}
                        appId="521270401588372"
                        title={`Post: "Found this company on Trevex and thought it might interest you"`}
                        className="Demo__some-network__share-button"
                      >
                        <Messenger className="h-[40px] w-[40px] sm:w-[50px] md:w-[100px] sm:h-[50px] md:h-[80px]" />
                      </FacebookMessengerShareButton>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                  <div className="flex justify-start text-f10 sm:text-f12 md:text-f16">
                    Page Link
                  </div>
                  <div className="flex items-center justify-between w-full ">
                    <input
                      placeholder="link / url"
                      className="h-[20px] w-full sm:h-[20px] md:h-[30px] py-2"
                      type="text"
                      value={shareUrl}
                      ref={company_urlRef}
                    />
                    <CommonTooltip id={"copy-tooltip"} content={copyText}>
                      <Copy
                        onClick={handleCopy}
                        onMouseDown={handleMouseDown}
                        className="h-[14px] w-[14px] sm:w-[18px] md:w-[24px] sm:h-[18px] md:h-[24px] cursor-pointer"
                      />
                    </CommonTooltip>
                  </div>
                </div>
              </div>
            </Modal>
          ) : null
        }
        {
          isRoleManageOpen ? (
            <>
              <Modal modalHandle={handleRoleManageClick}>
                <div style={{ width: 600 }}>
                  <div className="mb-3 text-left">
                    <h2 className="font-semibold">Manage Roles</h2>
                    <p className="text-[#a3a3a3]">Edit Role of users on this file</p>
                  </div>
                  <div className="relative w-100">
                    <div className="flex w-100 justify-between text-sm text-gray-900 border border-none sm:bg-white space-x-4  my-4">
                      <div>
                        <input
                          id="name"
                          className="block w-full p-2  text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                          placeholder="Enter Name"
                          name="name"
                          value={inviteData.name}
                          onChange={handleInviteChange}
                        />
                      </div>
                      <div className="grow">
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"></div>
                          <input
                            id="default-search"
                            className="block w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Email"
                            name="email"
                            value={inviteData.email}
                            onChange={handleInviteChange}
                          />

                          <Select
                            id="designation"
                            value={inviteData.role}
                            onChange={handleInviteChange}
                            name="role"
                            classes="absolute top-0 right-0"
                            icon={false}
                          >
                            {/* Note: This is Admin we made this temp change */}
                            <option value="AD">Manager</option>
                            <option value="ED">Editor</option>
                          </Select>
                        </div>
                      </div>
                    </div>
                    <div className="w-100">
                      <button
                        type="button"
                        onClick={handleInviteSubmit}
                        disabled={inviteData.name === "" || inviteData.email === "" || !validateEmail(inviteData?.email)}
                        className="w-[100%] flex items-center rounded-lg  justify-center text-white  sm:mt-0 mt-2 bottom-2.5 bg-primary font-sans text-sm  px-3 py-2"
                      >
                        {isInviteApiLoading ? <Spinner /> : "Send Invite"}
                      </button>
                    </div>
                  </div>

                  <div className="mt-3">
                    <ul className="list-reset">
                      {/* <li
                        className="flex py-2 px-4 justify-between items-center"
                        key={index}
                      >
                        <div className="flex space-x-4 items-center">
                          <img
                            src={
                              "https://avatars.githubusercontent.com/u/123456789?v=4"
                            }
                            className="w-10 rounded-full"
                            alt={user.name}
                          />
                          <p className="text-sm font-medium">{user.name}</p>
                        </div>

                        <div className="flex items-center">
                          <p className="text-sm text-gray-500">Owener</p>
                        </div>
                      </li> */}
                      {usersData.map((user, index) => (
                        <li
                          className="flex py-2 px-0 justify-between items-center"
                          key={index}
                        >
                          <div className="flex space-x-4 items-center">
                            <img
                              src={
                                "https://avatars.githubusercontent.com/u/123456789?v=4"
                              }
                              className="w-10 rounded-full"
                              alt={user.name}
                            />
                            <div className="text-left">
                              <p className="text-sm font-medium">{user.name}</p>
                              <p className="text-sm text-[10px] text-[#939393]">{user.email}</p>
                            </div>
                          </div>

                          {user.role === "CL" ? <div className="flex items-center gap-2">
                            <div
                              id="designation"
                              name="role"
                              className="text-[#002940] focus:outline-none bg-transparent"
                            >
                              {/* Note: this is Claimer we made this change for temp */}
                              Admin
                            </div>
                          </div> : <div className="flex items-center gap-2">
                            <Select
                              id="designation"
                              value={user.role}
                              onChange={(e) => handleRoleChange(e, user)}
                              name="role"
                              classes="absolue top-0 right-0"
                              icon={false}
                            >
                              {/* Note: this is Admin we made this change for temp */}
                              <option value="AD">Manager</option>
                              <option value="ED">Editor</option>
                            </Select>
                            <div className="border-l h-[24px]"></div>
                            <Delete className='cursor-pointer' onClick={(e) => handleUserDelete(e, user)} />
                          </div>}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Modal>
            </>
          ) : null
        }
      </Card >
      {isGetTheCompanyOpen && (
        <Modal modalHandle={handleGetCompanyPopup}>
          <GetTheCompany
            handleGetCompany={handleGetCompany}
            createWorldBoxOrder={createWorldBoxOrder}
            fromBanner
            SubscriptionActive={subscriptionActive?.no_of_profile_views >= 1 || userEnterprise?.length > 0}
            handlePurchased={() => setCreditNoticePopup(true)}
            company_id={id}
            isContinue={isContinue}
            setIsContinue={setIsContinue}
            secondayListedHandler={secondayListedHandler}
            formData={formData}
            setFormData={setFormData}
            acknowledgement={true}
            des={
              " The request is sourced from secondary sources and will take up to 5 working days."
            }
            button={"Continue"}
          />
        </Modal>
      )
      }
      {
        purchasedCompanyPopup && (
          <Modal modalHandle={handleRefresh}>
            <PurchaseSuccess
              onclick={handleRefresh}
              title={creditType === "credit" ? "Purchase Company Successful" : `Company Added to ${selectedEnterprise?.name}`}
              des={creditType === "credit" ? "Enjoy the Incredable Experience of the companies" : "The company is now added to the Tracking Companies Listing for this enterprise solution"}
              button={"continue"}
            />
          </Modal>
        )
      }
      {
        creditNoticePopup && (
          <Modal modalHandle={() => setCreditNoticePopup(false)}>
            <p className="text-f20 font-semibold text-left">Get this company</p>
            {userEnterprise?.length > 0 && <p className="text-f16 text-gray-500 text-left">select how you want to proceed to buy this company</p>}
            <CreditNotice
              onclick={() => setCreditNoticePopup(false)}
              handlePurchased={handlePurchased}
              company_id={id}
              NoCredits={!subscriptionActive || subscriptionActive?.no_of_profile_views == 0}
              title={
                subscriptionActive?.no_of_profile_views >= 1
                  ? "Attention!!"
                  : "Oopss..."
              }
              des={
                subscriptionActive?.no_of_profile_views >= 1
                  ? userEnterprise?.length > 0 ? `1 credit out of ${subscriptionActive?.no_of_profile_views
                    } credit(s)` : `You are about to use <b> 1 credit </b> for these request. You will be left with <b> ${SubscriptionActive?.no_of_profile_views - 1
                    } more credit of this month </b>`
                  : "No credits Left"
              }
              des2={`Currently you have <b> ${subscriptionActive?.no_of_profile_views} Credit </b>. Upgrade your plan to get more credit or else continue via payment method`}
              leftButton={
                subscriptionActive?.no_of_profile_views >= 1
                  ? "Cancel"
                  : "Buy Credits"
              }
              userInfo={userInfo}
              rightButton={"Process"}
              selectedEnterprise={selectedEnterprise}
              setSelectedEnterprise={setSelectedEnterprise}
              userEnterprise={userEnterprise}
            />
          </Modal>
        )
      }
    </div >
  );
};
